import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { useCurrentChainInfo } from "@looksrare/utils";
import { getCanonicalAndLanguageAlternates } from "config/seo";
import Page from "components/Layout/Page";
import AffiliateLandingPageView from "views/affiliate/AffiliateLandingPageView";

const AffiliateLandingPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = useCurrentChainInfo();
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    "/affiliate",
    router,
    currentChainInfo.appUrl
  );
  const title = "Refer Users and Earn ETH with the LooksRare Affiliate Program";
  const description =
    "Send users to LooksRare and earn up to 50% commissions on their fees. Apply for the LooksRare Affiliate Program today.";
  return (
    <Page>
      <NextSeo
        title={t("{{pageTitle}} | LooksRare", { pageTitle: title })}
        openGraph={{
          title: t("{{pageTitle}} | LooksRare", { pageTitle: title }),
          url: canonical,
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/affiliate-landing-page/meta.png`,
              alt: "LooksRare Affiliate Program",
              width: 1600,
              height: 900,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <AffiliateLandingPageView />
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
      locale,
    },
  };
};

export default AffiliateLandingPage;
